
import React from 'react'
import { Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import NavRouter from "./router/NavRouter";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import "./responsive.css";
import "animate.css/animate.min.css";
import { useEffect, useState } from "react";
import { BaseUrl } from './helper/BaseUrl';
import SEO from "./helper/SEO";
import { ModalProvider } from './contexts/ModalContext';

const hasValues = (data) => (
  data &&
  typeof data === "object" &&
  Object.values(data).some((value) => {
    if (value === null || value === undefined) return false;
    return String(value).trim() !== "";
  })
);

function App({ initialData, initialSeo, initialSchema }) {
  const [seoData, setSeoData] = useState(() => (hasValues(initialSeo) ? initialSeo : null));
  const [schemaData, setSchemaData] = useState(() => (hasValues(initialSchema) ? initialSchema : null));
  const location = useLocation();
 
  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.seo === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.seo);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    Detailfetcher();
  }, [location.pathname])

  useEffect(() => {
    if (hasValues(schemaData)) {
      return undefined;
    }

    const controller = new AbortController();

    const fetchSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          signal: controller.signal,
        });
        const result = await response.json();

        if (!response.ok || result.error) {
          throw new Error(result.message || "Unable to fetch schema data.");
        }

        if (hasValues(result.schema)) {
          setSchemaData(result.schema);
        }
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Schema fetch error:", error.message);
        }
      }
    };

    fetchSchema();
    return () => controller.abort();
  }, [schemaData]);

  //-------- 

  useEffect(() => {
    if (typeof window !== "undefined") {
      const existingSource = sessionStorage.getItem("source_url");
      if (!existingSource) {
        const landingUrl = window.location.href;
        sessionStorage.setItem("source_url", landingUrl);
      }
    }
  }, []);

   
  //-------- add "/" after url 
  function TrailingSlashRedirect() {
    const { pathname } = useLocation();

    if (!pathname.endsWith("/")) {
      return <Navigate to={pathname + "/"} replace />;
    }
    return null;
  }


  return (
    // <div className="App">
    //   <HelmetProvider>
    //     <BrowserRouter>
    //       <NavRouter />
    //     </BrowserRouter>
    //   </HelmetProvider>
    //   <ToastContainer/>
    // </div>

 
    <div className="App">
      <SEO seoData={seoData} schemaData={schemaData} />
      <ModalProvider>
        <NavRouter initialData={initialData}/>
      </ModalProvider>
      <ToastContainer />
      <TrailingSlashRedirect/>
    </div>
  );
}

export default App;
